import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useUserContext } from '@dfx.swiss/react';
import { IconColor, StyledInfoText } from '@dfx.swiss/react-components';
import { useSettingsContext } from '../contexts/settings.context';
export function SanctionHint() {
    const { translate } = useSettingsContext();
    const { user } = useUserContext();
    return user && user.kyc.level < 30 ? (_jsx(StyledInfoText, Object.assign({ iconColor: IconColor.BLUE }, { children: translate('screens/kyc', 'Note: Your account is not verified. Your transaction will only be processed if you do not have the same name as a sanctioned or politically exposed person.') }))) : (_jsx(_Fragment, {}));
}
